/**
 *               ! ВАЖНО !
 * Когда добавляешь новые шаги или ошибки,
 * не забудь обновить массив stepsWithoutInitialData в папке constants,
 * он нужен чтобы не запрашивать данные на ноде, когда основные шаги лендинга не отображаются
 **/
export enum EActivateInsuranceStep {
  Authorization = 'authorization',

  Insurance = 'insurance',
  Success = 'success',

  Error = 'error',
  ErrorInsuranceAlreadyAccepted = 'insuranceAlreadyAccepted',
  ErrorPublicOfferNotAccepted = 'publicOfferNotAccepted',

  Unexpected = 'unexpected',
}
